import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_API_URL, DEFAULT_AXIOS_OPTIONS } from "../../../AppConstants";
import { useAdminLoggedIn } from "../../../hooks";
import { AddCreator } from "./AddCreator";
import { ListCreators } from "./ListCreators";
import { UpdateCreator } from "./UpdateCreator";

export const Creator = () => {
  useAdminLoggedIn();

  const [lastChangeOccured, setLastChangeOccured] = useState(new Date());
  const [creators, setCreators] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_API_URL}/creator`, DEFAULT_AXIOS_OPTIONS)
      .then((res) => {
        setCreators(res.data);
      })
      .catch((error) => {
        console.error("error", error);
      });
  }, [lastChangeOccured]);

  return (
    <div>
      <h1>Creators (Admin)</h1>
      <div className="contents">
        <div className="content_element">
          <div className="column">
            <button
              className="btn btn-danger"
              onClick={() => (window.location.href = "/admin")}
            >
              Back
            </button>
          </div>
        </div>
        <div className="creator-actions">
          <div className="content_element col">
            <AddCreator setLastChangeOccured={setLastChangeOccured} />
          </div>
          <div className="content_element col">
            <UpdateCreator
              creators={creators}
              setLastChangeOccured={setLastChangeOccured}
            />
          </div>
        </div>
        <div className="content_element">
          <ListCreators
            creators={creators}
            setLastChangeOccured={setLastChangeOccured}
          />
        </div>
      </div>
    </div>
  );
};
